import Cookies from "js-cookie";

import { UserStatus } from "@/types";

export enum CookiesKeys {
  AccessToken = "access-token",
  RefreshToken = "refresh-token",
  UserStatus = "user-status",
  FinishedOnboarding = "finished-onboarding",
}

type ProfileEncryptedData = {
  _id: string;
  email: string;
  iat: number;
  exp: number;
};

class CookiesService {
  private static readonly accessTokenKey = CookiesKeys.AccessToken;
  private static readonly refreshTokenKey = CookiesKeys.RefreshToken;
  private static readonly userStatusKey = CookiesKeys.UserStatus;
  private static readonly finishedOnboardingKey = CookiesKeys.FinishedOnboarding;

  static getAccessToken(): string | undefined {
    return Cookies.get(this.accessTokenKey);
  }

  static setAccessToken(token: string): void {
    Cookies.set(this.accessTokenKey, token);
  }

  static deleteAccessToken(): void {
    Cookies.remove(this.accessTokenKey);
  }

  static getFinishedOnboardingValue(): boolean | undefined {
    return Cookies.get(this.finishedOnboardingKey) === "true" ? true : false;
  }

  static setFinishedOnboardingValue(value: boolean): void {
    Cookies.set(this.finishedOnboardingKey, String(value));
  }

  static deleteFinishedOnboardingToken(): void {
    Cookies.remove(this.finishedOnboardingKey);
  }

  static getRefreshToken(): string | undefined {
    return Cookies.get(this.refreshTokenKey);
  }

  static setRefreshToken(token: string): void {
    Cookies.set(this.refreshTokenKey, token);
  }

  static deleteRefreshToken(): void {
    Cookies.remove(this.refreshTokenKey);
  }

  static getUserStatus(): UserStatus | undefined {
    const status = Cookies.get(this.userStatusKey);
    return status ? (status as UserStatus) : undefined;
  }

  static setUserStatus(status: UserStatus): void {
    Cookies.set(this.userStatusKey, status);
  }

  static deleteUserStatus(): void {
    Cookies.remove(this.userStatusKey);
  }

  static deleteAuthTokens(): void {
    this.deleteAccessToken();
    this.deleteRefreshToken();
  }

  static getMyId() {
    const accessToken = this.getAccessToken();

    if (accessToken) {
      const encryptedData = accessToken.split(".")[1];

      const { _id } = JSON.parse(atob(encryptedData as string)) as ProfileEncryptedData;

      return _id;
    }
  }
}

export { CookiesService };
